import { createContext, useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import { flyToCart } from "../../utils/flyToCart";
import api from "../../api";
import { useModal } from "../../ModalContext";
import { CgDanger } from "react-icons/cg";

const CartContext = createContext();
export const CartProvider = ({ children }) => {
  const { openModal } = useModal();
  const [cartItems, setCartItems] = useState(() => {
    try {
      const stored = localStorage.getItem("cartItems");
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  });
  const [termsAccepted, setTermsAccepted] = useState(false);
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  // const addToCart = (item, qty,sourceEl = null) => {
  //   const cartItem = {
  //     id: item.id || item._id || item.titleEn,
  //     title: item.titleEn,
  //     price: Number(item.price) || 0,
  //     image: `http://api.righttracklb.com/${item.cover_front}`,
  //     qty: qty ?? 1,
  //     maxQty: item.qty,
  //   };
  // const existing = cartItems.find((x) => x.id === cartItem.id);

  //   if (existing) {
  //     // 🔥 Check stock
  //     if (existing.qty >= existing.maxQty) {
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Stock Limit Reached",
  //         text: `Only ${existing.maxQty} available for this product.`,
  //         confirmButtonColor: "#000",
  //         customClass: {
  //           popup: "my-swal-popup",
  //         },
  //       });
  //       return; // lock at max
  //     }

  //     setCartItems((prev) =>
  //       prev.map((x) =>
  //         x.id === cartItem.id ? { ...x, qty: x.qty + 1 } : x
  //       )
  //     );
  //   } else {
  //     // first time adding
  //     setCartItems((prev) => [cartItem, ...prev]);
  //   }

  //   if (sourceEl) {
  //     flyToCart(sourceEl, cartItem.image);
  //   }
  // };

  const addToCart = async (item, qty, sourceEl = null) => {
    // const testIp = "188.170.72.89";
    const testIp = "178.135.244.151";
    // try {
    //   const res = await api.post("zone/check-zone", {
    //       productId: item.id || item._id,
    //       clientIp: testIp
    //   });

    //   const data = res.data;

    //   if (!data.ok) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Not Available in Your Region",
    //       text:
    //         data.message || "This product cannot be purchased in your area.",
    //       confirmButtonColor: "#000",
    //       customClass: {
    //         popup: "my-swal-popup",
    //       },
    //     });
    //     return; // stop adding
    //   }
    // } catch (err) {
    //   console.error("Zone check failed:", err);
    //   return;
    // }
    try {
      const res = await api.post("zone/check-zone", {
        productId: item.id || item._id,
        clientIp: testIp,
      });

      const data = res.data;

      if (!data.ok) {
        openModal(
          <CgDanger size={40} color="#993400" />,
          "Not Available in Your Region",
          data.message || "This product cannot be purchased in your area.",
        );

        return; // stop adding
      }
    } catch (err) {
      console.error("Zone check failed:", err);

      openModal(
        <CgDanger size={40} color="#993400" />,
        "Error",
        "Something went wrong while checking your region.",
      );

      return;
    }
    // 2️⃣ Proceed normally if allowed
    const cartItem = {
      id: item.id || item._id || item.titleEn,
      title: item.titleEn,
      price: Number(item.price) || 0,
      image: `http://api.righttracklb.com/assets/images/${item.cover_front}`,
      qty: qty ?? 1,
      maxQty: item.qty,
    };

    const existing = cartItems.find((x) => x.id === cartItem.id);

    if (existing) {
      if (existing.qty >= existing.maxQty) {
        Swal.fire({
          icon: "warning",
          title: "Stock Limit Reached",
          text: `Only ${existing.maxQty} available for this product.`,
          confirmButtonColor: "#000",
          customClass: { popup: "my-swal-popup" },
        });
        return;
      }
      // setCartItems((prev) =>
      //   prev.map((x) => (x.id === cartItem.id ? { ...x, qty: x.qty + 1 } : x)),
      // );
      setCartItems((prev) =>
        prev.map((x) => (x.id === cartItem.id ? { ...x, qty: x.qty + qty } : x)),
      );

    } else {
      setCartItems((prev) => [cartItem, ...prev]);
    }

    if (sourceEl) {
      flyToCart(sourceEl, cartItem.image);
    }
  };
  const removeItem = (id) =>
    setCartItems((prev) => prev.filter((x) => x.id !== id));

  const increaseQty = (id) =>
    setCartItems((prev) =>
      prev.map((x) => {
        if (x.id === id) {
          if (x.qty >= x.maxQty) {
            Swal.fire({
              icon: "warning",
              title: "Out of Stock",
              text: `Only ${x.maxQty} available for this product.`,
              confirmButtonColor: "#000",
              customClass: {
                popup: "my-swal-popup",
              },
            });
            return { ...x, qty: x.maxQty }; // lock at max
          }
          return { ...x, qty: x.qty + 1 };
        }
        return x;
      }),
    );
  const decreaseQty = (id) =>
    setCartItems((prev) =>
      prev
        .map((x) => (x.id === id ? { ...x, qty: x.qty - 1 } : x))
        .filter((x) => x.qty > 0),
    );

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeItem,
        increaseQty,
        decreaseQty,
        termsAccepted,
        setTermsAccepted,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
